import { SearchLanguages } from "../types";

// feature_six_browse-bin
export const searchLanguages: { [key in SearchLanguages]: string } = {
  en: "18685580011",
  es: "18685609011",
  de: "18685583011",
  fr: "18685582011",
  it: "18685590011",
  pt: "18685603011",
  ja: "18685591011",
  ru: "18685606011",
  af: "18685571011",
  da: "18685578011",
  zh: "18685596011",
  nl: "18685579011",
};

// node=18571910011
export const searchCategories = {
  // Arts & Entertainment
  artsAndEntertainment: "18571910011",
  // Biographies & Memoirs
  biographiesAndMemoirs: "18571951011",
  // Business & Careers
  businessAndCareers: "18572029011",
  // Children's Audiobooks
  childrensAudiobooks: "18572091011",
  // Computers & Technology
  computersAndTechnology: "18573211011",
  // Education & Learning
  educationAndLearning: "18573267011",
  // Erotica
  erotica: "18573351011",
  // Health & Wellness
  heathAndWellness: "18573370011",
  // History
  history: "18573518011",
  // Home & Garden
  homeAndGarden: "18573701011",
  // LGBTQ+
  lgbtq: "18573743011",
  // Literature & Fiction
  literatureAndFiction: "18574426011",
  // Money & Finance
  moneyAndFinance: "18574547011",
  // Mystery, Thriller & Suspense
  mysteryThrillerAndSuspense: "18574597011",
  // Politics & Social Sciences
  politicsAndSocialSciences: "18574641011",
  // Relationships, Parenting & Personal Development
  relationshipsParentingAndPersonalDevelopment: "18574784011",
  // Religion & Spirituality
  religionAndSpirituality: "18574839011",
  // Romance
  romance: "18580518011",
  // Science & Engineering
  scienceAndEngineering: "18580540011",
  // Science Fiction & Fantasy
  scienceFictionAndFantasy: "18580606011",
  // Sports & Outdoors
  sportsAndOutdoors: "18580648011",
  // Teen & Young Adult
  teenAndYoungAdult: "18580715011",
  // Travel & Tourism
  travelAndTourism: "18581095011",
};

// feature_seven_browse-bin
export const searchDurations = {
  "<1": "18685630011",
  "1-3": "18685631011",
  "3-6": "18685632011",
  "6-10": "18685633011",
  "10-20": "18685634011",
  ">20": "18685635011",
};

// publication_date
export const releaseTimes = {
  soon: "18685637011",
  last30: "18685638011",
  last90: "18685639011",
};

export const pageSizes = [20, 30, 40, 50];

export const siteCountries = {
  us: {
    url: "https://www.audible.com",
    language: "en",
  },
  ca: {
    url: "https://www.audible.ca",
    language: "en",
  },
  gb: {
    url: "https://www.audible.co.uk",
    language: "en",
  },
  au: {
    url: "https://www.audible.com.au",
    language: "en",
  },
  fr: {
    url: "https://www.audible.fr",
    language: "fr",
  },
  de: {
    url: "https://www.audible.de",
    language: "de",
  },
  it: {
    url: "https://www.audible.it",
    language: "it",
  },
};

export const audibleOriginal = {
  "feature_ten_browse-bin": "18685526011",
};

export const plusCatalog = {
  audible_programs: "20956260011",
};

export const whispersync = {
  "feature_three_browse-bin": "18685781011",
};

export const abridged = {
  "feature_nine_browse-bin": "18685523011",
};

export const unabridged = {
  "feature_nine_browse-bin": "18685524011",
};

export const audiobookFormat = {
  "feature_twelve_browse-bin": "18685552011",
};

export const podcastFormat = {
  "feature_twelve_browse-bin": "21201078011",
};

export const podcastShowFormat = {
  "feature_twenty-two_browse-bin": "21615422011",
};

export const podcastEpisodeFormat = {
  "feature_twenty-two_browse-bin": "21615423011",
};
